import { PlacementPage } from "components/feature";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { communitySearchInitializeEvent } from "store/actions/communities";
import { buildLocationFilterSearchInstance } from "store/reducers/community-search";
import { usePreferences, useRegionId } from "store/selectors/hooks";
import { currentLocale } from "store/selectors/regions";
import { useRegionSettings } from "store/selectors/settings";
import { Content, ContentContainer, PageHeader, Stage } from "../layout";
import { AddNewCommunityButton } from "./add-new-community-button";
import { CommunitySearchResults } from "./community-search-results";
import { SearchCommunity } from "./search-bar/search-bar";

export const CommunitySearch = () => {
    const dispatch = useDispatch();
    const preferences = usePreferences();
    const {
        settings: {
            defaultCommunitySearch,
            showCommunityBaseAndHighPrice,
            communityCardContactMode,
        },
        status: settingsStatus,
    } = useRegionSettings();
    const defaultCommunitySortOrder = preferences.defaultCommunitySortOrder;
    const regionId = useRegionId("community");
    const locale = useSelector(currentLocale);
    const searchKey = useMemo(() => `dashboard-${regionId}`, [regionId]);

    const defaultSearchInstance = useMemo(
        () =>
            buildLocationFilterSearchInstance(
                defaultCommunitySearch,
                regionId,
                defaultCommunitySortOrder,
                locale,
            ),
        [defaultCommunitySearch, regionId, defaultCommunitySortOrder, locale],
    );

    useEffect(() => {
        if (settingsStatus !== "success") return;
        dispatch(
            communitySearchInitializeEvent(
                searchKey,
                defaultCommunitySortOrder,
                regionId,
                defaultSearchInstance,
            ),
        );
    }, [searchKey, regionId, settingsStatus, dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <PlacementPage>
            <Stage>
                <PageHeader title="Communities">
                    <AddNewCommunityButton />
                </PageHeader>
                <Content>
                    <SearchCommunity
                        includedExcludedEnabled={false}
                        searchKey={searchKey}
                        defaultCommunitySearch={defaultCommunitySearch}
                        defaultSearchInstance={defaultSearchInstance}
                        showCommunityBaseAndHighPrice={showCommunityBaseAndHighPrice}
                    />
                </Content>
                <ContentContainer className="mt-2 lg:mt-4 mx-0! p-4 bg-zinc-50">
                    <CommunitySearchResults
                        searchKey={searchKey}
                        communityCardContactMode={communityCardContactMode}
                    />
                </ContentContainer>
            </Stage>
        </PlacementPage>
    );
};
